/* FÉNIX R07 · UNIVERSAL HOLOGRAM RUNTIME BRIDGE v03 · product-neutral */
(()=>{
  const clamp=(n,a,b)=>Math.max(a,Math.min(b,n));
  const fine=()=>window.matchMedia&&window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  const reduced=()=>window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const prepMolecules=(master)=>{
    master.querySelectorAll('.fnx-molecule').forEach(mol=>{
      if(mol.hasAttribute('data-fnx-molecule-hologram'))return;
      if(mol.querySelector('.fnx-molecule-stage')&&mol.querySelector('.fnx-molecule-svg')){
        mol.setAttribute('data-fnx-molecule-hologram','runtime-v03');
      }
    });
  };

  const bindTimeline=(tl)=>{
    if(tl.dataset.fnxRuntimeTl==='1')return;
    tl.dataset.fnxRuntimeTl='1';
    const items=Array.from(tl.children).filter(el=>el.tagName==='LI');
    if(!items.length)return;
    const host=tl.closest('.fnx-history,.history,.fnx-section')||tl;
    let target=0,current=0,raf=0;

    const draw=()=>{
      raf=0;
      current+=(target-current)*.24;
      if(Math.abs(target-current)<.001)current=target;
      tl.style.setProperty('--fnx-cursor-progress',(current*100).toFixed(2)+'%');
      const tr=tl.getBoundingClientRect();
      items.forEach(item=>{
        const marker=item.querySelector('.fnx-node,.n');
        const r=(marker||item).getBoundingClientRect();
        const p=clamp(((r.top+(marker?r.height/2:Math.min(12,r.height*.18)))-tr.top)/Math.max(1,tr.height),0,1);
        const active=Math.abs(current-p)<=.065;
        item.classList.toggle('fnx-runtime-active',active);
        item.classList.toggle('fnx-runtime-past',!active&&current>p);
      });
      if(Math.abs(target-current)>.001)raf=requestAnimationFrame(draw);
    };
    const schedule=()=>{if(!raf)raf=requestAnimationFrame(draw)};
    const setFromY=(clientY)=>{
      const r=tl.getBoundingClientRect();
      target=clamp((clientY-r.top)/Math.max(1,r.height),0,1);
      schedule();
    };

    if(fine()&&!reduced()){
      host.addEventListener('pointermove',e=>{if(e.pointerType==='touch')return;setFromY(e.clientY)},{passive:true});
      host.addEventListener('pointerleave',()=>{target=0;schedule()},{passive:true});
    }else{
      let ticking=false;
      const update=()=>{
        ticking=false;
        const r=tl.getBoundingClientRect();
        const trigger=window.innerHeight*.67;
        target=clamp((trigger-r.top)/Math.max(1,r.height),0,1);
        schedule();
      };
      const request=()=>{if(!ticking){ticking=true;requestAnimationFrame(update)}};
      window.addEventListener('scroll',request,{passive:true});
      window.addEventListener('resize',request,{passive:true});
      request();
    }
    tl.closest('details')?.addEventListener('toggle',()=>requestAnimationFrame(()=>{const r=tl.getBoundingClientRect();if(r.height>0){tl.style.setProperty('--fnx-cursor-progress',(current*100).toFixed(2)+'%')}}),{passive:true});
    schedule();
  };

  const bindStage=(stage)=>{
    if(stage.dataset.fnxRuntimeStage==='1')return;
    stage.dataset.fnxRuntimeStage='1';

    const compact=stage.matches('.fnx-v,.fnx-visual');
    const compactCore=compact?stage.querySelector('.fnx-core'):null;
    const compactRings=compact?Array.from(stage.querySelectorAll('.fnx-r,.fnx-ring')):[];
    compactRings.forEach(r=>{r.style.setProperty('animation','none','important')});
    if(compactCore){
      compactCore.style.transformStyle='preserve-3d';
      compactCore.style.transition='transform .16s cubic-bezier(.16,1,.3,1),filter .2s ease';
      compactCore.style.filter='drop-shadow(0 0 10px rgba(186,250,255,.48)) drop-shadow(0 0 26px rgba(43,225,255,.28))';
    }

    if(!fine()||reduced()){
      if(compactCore)compactCore.style.transform='none';
      return;
    }
    let tx=.5,ty=.48,cx=.5,cy=.48,inside=false,raf=0;
    const draw=()=>{
      raf=0;
      cx+=(tx-cx)*.20;cy+=(ty-cy)*.20;
      const rx=(.5-cy)*5.2;
      const ry=(cx-.5)*7.4;
      stage.style.setProperty('--fnx-stage-x',(cx*100).toFixed(1)+'%');
      stage.style.setProperty('--fnx-stage-y',(cy*100).toFixed(1)+'%');
      stage.style.setProperty('--fnx-stage-rx',rx.toFixed(2)+'deg');
      stage.style.setProperty('--fnx-stage-ry',ry.toFixed(2)+'deg');
      stage.style.setProperty('--fnx-stage-hot',inside?'1':'0');
      if(compactCore){
        compactCore.style.transform=`rotateX(${rx.toFixed(2)}deg) rotateY(${ry.toFixed(2)}deg) translateZ(${inside?18:10}px)`;
      }
      if(Math.abs(tx-cx)>.001||Math.abs(ty-cy)>.001)raf=requestAnimationFrame(draw);
    };
    const schedule=()=>{if(!raf)raf=requestAnimationFrame(draw)};
    stage.addEventListener('pointerenter',()=>{inside=true;schedule()},{passive:true});
    stage.addEventListener('pointermove',e=>{
      if(e.pointerType==='touch')return;
      const r=stage.getBoundingClientRect();
      tx=clamp((e.clientX-r.left)/Math.max(1,r.width),0,1);
      ty=clamp((e.clientY-r.top)/Math.max(1,r.height),0,1);
      inside=true;schedule();
    },{passive:true});
    stage.addEventListener('pointerleave',()=>{inside=false;tx=.5;ty=.48;schedule()},{passive:true});
  };

  const boot=()=>{
    document.querySelectorAll('[data-fnx-hologram-master]').forEach(master=>{
      prepMolecules(master);
      master.querySelectorAll('.fnx-tl,.tl').forEach(bindTimeline);
      master.querySelectorAll('.fnx-profile,.visual,.fnx-art,.fnx-v,.fnx-visual').forEach(bindStage);
      master.classList.add('fnx-runtime-v03');
    });
  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
